<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div class="common_title">
        开仓记录
        <TopPartner @refreshTopPartner="handleSearch"></TopPartner>
      </div>

      <div class="page-actions">
        <div class="select">
          <div class="item">
            <!-- <div class="txt">用户UID</div> -->
            <div class="ipt">
              <el-input
                placeholder="用户UID"
                clearable
                v-model="userId"
                class="userUid_ipt"
                size="mini"
              >
                <!-- <img :src="userUid" alt="" slot="prefix" class="userUid" /> -->
              </el-input>
            </div>
          </div>
          <!-- <div class="item">
            <div class="txt">邀请人UID</div>
            <div class="ipt">
              <el-input placeholder="邀请人UID" clearable v-model="inviteBy">
              </el-input>
            </div>
          </div> -->
          <div class="item">
            <div class="ipt">
              <el-input placeholder="仓位ID" clearable v-model="positionId" size="mini">
              </el-input>
            </div>
          </div>
          <div class="item">
            <el-select v-model="source" size="mini" placeholder="仓位类型" @change="handleSearch">
              <el-option label="全部" value="ALL" />
              <el-option label="正常仓位" value="NORMAL" />
              <el-option label="体验仓位" value="POSITION_EXPERIENCE" />
            </el-select>
          </div>
          <div class="item">
            <!-- <div class="txt">合伙人UID</div> -->
            <div class="ipt">
              <el-input
                placeholder="合伙人UID"
                clearable
                v-model="channelUserId"
                class="userUid_ipt"
                size="mini"
              >
                <!-- <img :src="channel" alt="" slot="prefix" class="userUid" /> -->
              </el-input>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">仓位模式</div> -->
            <div class="ipt">
              <el-select
                size="mini"
                @change="changeCoin"
                :rules="[
                  { required: true, message: '请选择', trigger: 'change' },
                ]"
                v-model="positionType"
                placeholder="请选择"
              >
                <el-option label="全部仓位模式" value=""> </el-option>
                <el-option
                  v-for="item in [
                    { id: 1, value: '全仓' },
                    { id: 2, value: '逐仓' },
                  ]"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">买卖方向</div> -->
            <div class="ipt">
              <el-select
                size="mini"
                @change="changeCoin"
                :rules="[
                  { required: true, message: '请选择', trigger: 'change' },
                ]"
                v-model="orderSide"
                placeholder="请选择"
              >
                <el-option label="全部买卖方向" value=""> </el-option>
                <el-option
                  v-for="item in [
                    { id: 1, value: '买' },
                    { id: 2, value: '卖' },
                  ]"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">订单类型</div> -->
            <div class="ipt">
              <el-select
                size="mini"
                @change="changeCoin"
                :rules="[
                  { required: true, message: '请选择', trigger: 'change' },
                ]"
                v-model="orderType"
                placeholder="请选择"
              >
                <el-option label="全部订单类型" value=""> </el-option>
                <el-option
                  v-for="item in [
                    { id: 1, value: '限价' },
                    { id: 2, value: '市价' },
                  ]"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="item">
            <!-- <div class="txt">合约名</div> -->
            <div class="ipt">
              <el-select
                v-model="symbolId"
                clearable
                placeholder="请选择"
                size="mini"
              >
                <el-option value="" label="全部合约名"></el-option>
                <el-option
                  v-for="item in symbolList"
                  :key="item.id"
                  :label="item.symbol"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">开仓时间</div> -->
            <div class="ipt">
              <el-date-picker
                size="mini"
                v-model="value1"
                type="daterange"
                align="right"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                unlink-panels
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="changeTime($event)"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </div>
          </div>
          <!-- <div class="item">
            <el-button size="mini" @click="searchYesterday">昨日</el-button>
          </div>
          <div class="item">
            <el-button size="mini" @click="searchToday">今日</el-button>
          </div> -->
          <div class="item">
            <div class="item-sle">
              <div class="tit">特殊账号</div>
              <el-select
                size="mini"
                @change="changeCoin"
                v-model="type"
                placeholder="特殊账号"
              >
                <el-option
                  v-for="item in [
                    { id: 1, value: '隐藏' },
                    { id: 2, value: '显示' },
                  ]"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <el-button size="mini" type="primary" @click="handleSearch"
              >查询</el-button
            >
          </div>
          <div class="item">
            <a @click="getExcel" target="_blank">导出Excel</a>
          </div>
        </div>
      </div>
      <user-list @refresh="refreshList"></user-list>
    </el-card>
    <!-- 添加用户信息弹框 -->
  </div>
</template>

<script>
import "./store";
import UserList from "./components/list";
import { mapState, mapActions, mapMutations } from "vuex";
import { QUERY_TYPE, PAGINATION } from "./constants";
import moment from "moment";
import userUid from "@/assets/input/userUid.png";
import invite from "@/assets/input/invite.png";
import channel from "@/assets/input/channel.png";
import TopPartner from "../topPartner";

export default {
  name: "TranscationRecord",
  components: {
    UserList,
    TopPartner,
  },
  data() {
    return {
      source: "NORMAL",
      invite,
      channel,
      userUid,
      type: 1,
      orderType: "",
      positionType: "",
      orderSide: "",
      value2: "",
      dialogVisible: false,
      userId: "",
      channelId: "",
      channelUserId: "",
      symbolId: "",
      value1: "",
      positionId:"",
      // value1: [
      //   moment(new Date().getTime() - 7 * 1000 * 24 * 60 * 60).format(
      //     'YYYY-MM-DD'
      //   ),
      //   new Date().getFullYear() +
      //     '-' +
      //     (new Date().getMonth() + 1) +
      //     '-' +
      //     new Date().getDate(),
      // ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("transcationRecord", [
      "queryType",
      "queryTypeList",
      "pagination",
      "symbolList",
    ]),
    ...mapState(["userInfo"]),
    // ...mapState('spotassets', ["cionList"]),
    ...mapState("topPartner", ["topPartner"]),
  },
  methods: {
    // ...mapActions("spotassets", ["getCoinList"]),
    ...mapActions("transcationRecord", [
      "list",
      "getSymbolList",
      "exportExcel",
    ]),
    ...mapMutations("transcationRecord", ["setQueryType"]),
    refreshList(data = {}) {
      this.list({
        source: this.source,
        positionType: this.positionType,
        orderType: this.orderType,
        orderSide: this.orderSide,
        symbolId: this.symbolId,
        type: this.type,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        channelId: this.topPartner,
        channelUserId: this.channelUserId,
        userId: this.userId,
        positionId:this.positionId,
        ...this.pagination,
        ...data,
      });
    },
    getExcel() {
      this.exportExcel({
        source: this.source,
        positionType: this.positionType,
        orderType: this.orderType,
        orderSide: this.orderSide,
        symbolId: this.symbolId,
        type: this.type,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        channelId: this.topPartner,
        channelUserId: this.channelUserId,
        userId: this.userId,
        positionId:this.positionId,
        ...this.pagination,
      }).then(async (res) => {
        if (!(res instanceof Blob)) throw new Error('导出失败，请重试');
        if (/json|text/i.test(res.type)) {
          const message = JSON.parse(await res.text());
          throw new Error(message.msg || '导出失败，请重试');
        }
        const link = document.createElement("a");
        const blob = new Blob([res], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }); //设置文件流
        link.style.display = "none";
        // 设置连接
        link.href = URL.createObjectURL(blob); //将文件流转化为blob地址
        link.download = "开仓记录.xlsx";
        document.body.appendChild(link);
        // 模拟点击事件
        link.click(); //设置点击事件
        URL.revokeObjectURL(link.href);
        link.remove();
      }).catch(error => this.$message.error(error.message || "导出失败，请重试"));
    },
    changeTime(e) {
      this.list({
        source: this.source,
        positionType: this.positionType,
        orderSide: this.orderSide,
        channelId: this.topPartner,
        channelUserId: this.channelUserId,
        orderType: this.orderType,
        type: this.type,
        userId: this.userId,
        positionId:this.positionId,
        symbolId: this.symbolId,
        startTime: e[0],
        endTime: e[1],
        ...PAGINATION,
      });
    },
    searchYesterday() {
      this.value1 = [
        moment(new Date().getTime() - 1 * 1000 * 24 * 60 * 60).format(
          "YYYY-MM-DD"
        ),
        moment(new Date().getTime() - 1 * 1000 * 24 * 60 * 60).format(
          "YYYY-MM-DD"
        ),
      ];
      this.handleSearch();
    },
    searchToday() {
      this.value1 = [
        new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate(),
        new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate(),
      ];
      this.handleSearch();
    },
    handleSearch() {
      this.list({
        source: this.source,
        positionType: this.positionType,
        orderType: this.orderType,
        type: this.type,
        orderSide: this.orderSide,
        channelId: this.topPartner,
        channelUserId: this.channelUserId,
        userId: this.userId,
        positionId:this.positionId,
        symbolId: this.symbolId,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        ...PAGINATION,
      });
    },
    handleSave() {},
    closeDialog() {
      this.dialogVisible = false;
    },
    onOpen() {},
    onClose() {
      this.$refs["elForm"].resetFields();
      this.dialogVisible = false;
    },
    close() {
      // this.$emit("update:visible", false);
      this.$refs["elForm"].resetFields();
      this.dialogVisible = false;
    },
    changeCoin() {
      this.list({
        source: this.source,
        positionType: this.positionType,
        orderType: this.orderType,
        type: this.type,
        orderSide: this.orderSide,
        channelId: this.topPartner,
        channelUserId: this.channelUserId,
        userId: this.userId,
        positionId:this.positionId,
        symbolId: this.symbolId,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        ...PAGINATION,
      });
    },
  },
  created() {
    this.getSymbolList();
    this.list({
      source: this.source,
      positionType: this.positionType,
      orderType: this.orderType,
      type: this.type,
      orderSide: this.orderSide,
      channelId: this.topPartner,
      channelUserId: this.channelUserId,
      userId: this.userId,
      positionId:this.positionId,
      symbolId: this.symbolId,
      startTime: this.value1 ? this.value1[0] : "",
      endTime: this.value1 ? this.value1[1] : "",
      ...PAGINATION,
    });
  },
};
</script>

<style lang="less" src="../../../styles/button.less" scoped></style>
